'use strict';

var Field = require('./Field');

require('../../services/utils.service');

angular.module('dekky.forms.fields.radioCollection', ['dekky.forms.utils'])
	.factory('RadioCollectionField', function($log, $q, formsUtils) {
		function radioCollectionFactory(name, options, items) {
			function RadioCollection(name, options, items) {
				if (!Array.isArray(items)) {
					throw new Error('Not items for radio inputs');
				}
				if (angular.isUndefined(options.radio)) {
					throw new Error('Not options for radio input');
				}
				this.type = 'radioCollection';
				this.items = items;
				this.radio = options.radio;
				this.radioAttributes = options.radioAttributes || {};

				Field.apply(this, arguments);
			}

			RadioCollection.prototype = Object.create(Field.prototype);
			RadioCollection.prototype.link = function(template) {
				var radio = template.find('input');

				angular.forEach(this.radioAttributes, function(value, attr) {
					if (angular.isFunction(value)) {
						radio.attr(formsUtils.camelToDash(attr), 'field.radioAttributes.' + attr + '()');
					} else {
						radio.attr(formsUtils.camelToDash(attr), value);
					}
				});

				return $q.when(template);
			};

			return new RadioCollection(name, options, items);
		}

		return radioCollectionFactory;
	});